/*import { useEffect, useState } from "react";
import api from "../services/api";

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  const fetchStats = async () => {
    const res = await api.get("/admin/stats");
    setStats(res.data);
  };

  useEffect(() => {
    fetchStats();
  }, []);

  if (!stats) {
    return <p>Chargement...</p>;
  }

  return (
    <div>
      <h1 style={{ color: "#0B3C5D" }}>
        📊 Dashboard Dieulsima
      </h1>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: 20,
        marginTop: 20
      }}>

        <Card title="Users" value={stats.users} />
        <Card title="Drivers" value={stats.drivers} />
        <Card title="Rides" value={stats.rides} />
        <Card title="Revenue" value={`${stats.revenue} CFA`} />

      </div>
    </div>
  );
}

function Card({ title, value }) {
  return (
    <div style={{
      background: "#fff",
      padding: 20,
      borderRadius: 10,
      borderLeft: "5px solid #FFA500"
    }}>
      <h3 style={{ color: "#0B3C5D" }}>{title}</h3>
      <p style={{ fontSize: 22, fontWeight: "bold" }}>
        {value}
      </p>
    </div>
  );
}
  */


import { useEffect, useState } from "react";
import api from "../services/api";

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get("/admin/stats")
      .then(res => setStats(res.data))
      .catch(() => setError("Impossible de charger les statistiques."));
  }, []);

  if (error) return <p style={{ color: "red", padding: 20 }}>{error}</p>;
  if (!stats) return <p style={{ padding: 20 }}>Chargement...</p>;

  return (
    <div style={{ padding: "1.5rem 0" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "2rem" }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 500, color: "#0B3C5D" }}>
            📊 Dashboard Dieulsima
          </h1>
          <p style={{ fontSize: 14, color: "#888", marginTop: 4 }}>Vue d'ensemble de votre plateforme</p>
        </div>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12, padding: "4px 12px", borderRadius: 20, background: "#E6F1FB", color: "#185FA5", border: "0.5px solid #B5D4F4" }}>
          <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#1D9E75", display: "inline-block" }}></span>
          En direct
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: "2rem" }}>
        <StatCard label="Utilisateurs" value={stats.users} icon="👤" color="#E6F1FB" />
        <StatCard label="Chauffeurs"   value={stats.drivers} icon="🚗" color="#FAEEDA" />
        <StatCard label="Courses"      value={stats.rides} icon="🛣️" color="#EAF3DE" />
        <StatCard label="Revenus"      value={`${stats.revenue.toLocaleString("fr-FR")} CFA`} icon="💰" color="#FAECE7" />
      </div>
    </div>
  );
}

function StatCard({ label, value, icon, color }) {
  return (
    <div style={{ background: "#f7f7f7", borderRadius: 8, padding: "1rem" }}>
      <div style={{ fontSize: 12, color: "#888", display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }}>
        <span style={{ width: 28, height: 28, borderRadius: "50%", background: color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15 }}>{icon}</span>
        {label}
      </div>
      <div style={{ fontSize: 26, fontWeight: 500, color: "#0B3C5D" }}>{value}</div>
    </div>
  );
}